import {
  SET_COUNTRY_OF_TODAY,
  SET_SELECTED_GAME,
  SET_COMPLETED_STATE,
  COUNTRY_GAME_COMPLETED,
  PATCH_GAME_COUNTRY,
  NEIGHBOURS_GAME_COMPLETED,
  PATCH_GAME_NEIGHBOURS,
  CAPITAL_GAME_COMPLETED,
  PATCH_GAME_CAPITAL,
  FLAG_GAME_COMPLETED,
  PATCH_GAME_FLAG,
  SPOKEN_LANGUAGE_GAME_COMPLETED,
  PATCH_GAME_SPOKEN_LANGUAGE,
  POPULATION_GAME_COMPLETED,
  PATCH_GAME_POPULATION,
  POPULOUS_CITIES_GAME_COMPLETED,
  PATCH_GAME_POPULOUS_CITIES,
  AREA_GAME_COMPLETED,
  PATCH_GAME_AREA,
  CURRENCY_GAME_COMPLETED,
  PATCH_GAME_CURRENCY,
} from "../actions/type";
import gameConstants from "../constants/game";
import {
  GAME_COUNTRY,
  GAME_NEIGHBOURS,
  GAME_CAPITAL,
  GAME_FLAGS,
  GAME_SPOKEN_LANGUAGE,
  GAME_POPULATION,
  GAME_CURRENCY,
  GAME_POPULOUS_CITIES,
  GAME_AREA,
} from "../constants/gameTypes";

export const setCountryOfToday = (countryOfToday) => (dispatch) => {
  let gamesOfToday = [
    GAME_COUNTRY,
    GAME_NEIGHBOURS,
    GAME_CAPITAL,
    GAME_FLAGS,
    GAME_SPOKEN_LANGUAGE,
    GAME_POPULATION,
    GAME_CURRENCY,
    GAME_POPULOUS_CITIES,
    GAME_AREA,
  ];
  const { borders, quiz, capital, currency_name, languages, cities } =
    countryOfToday;
  if (!borders || borders.length < 1) {
    gamesOfToday = gamesOfToday.filter((item) => item !== GAME_NEIGHBOURS);
  }
  if (!languages || languages.length < 1) {
    gamesOfToday = gamesOfToday.filter((item) => item !== GAME_SPOKEN_LANGUAGE);
  }
  if (!quiz) {
    gamesOfToday = gamesOfToday.filter((item) => item !== GAME_POPULATION);
  }
  if (!capital) {
    gamesOfToday = gamesOfToday.filter((item) => item !== GAME_CAPITAL);
  }
  if (!currency_name) {
    gamesOfToday = gamesOfToday.filter((item) => item !== GAME_CURRENCY);
  }
  if (!cities || cities.length < 3) {
    gamesOfToday = gamesOfToday.filter((item) => item !== GAME_POPULOUS_CITIES);
  }

  gamesOfToday = gameConstants.categories
    .filter((item) => gamesOfToday.includes(item.key))
    .map((item, index) => ({
      ...item,
      index,
    }));

  dispatch({
    type: SET_COUNTRY_OF_TODAY,
    countryOfToday,
    gamesOfToday,
  });
};

export const handleNext = () => (dispatch, getState) => {
  const { gamesOfToday, selectedGame } = getState().game;
  let currentIdx = gamesOfToday?.findIndex(
    (item) => item.key === selectedGame?.key,
  );
  let target = selectedGame;
  if (currentIdx >= gamesOfToday.length - 1) target = gamesOfToday[0];
  else target = gamesOfToday[currentIdx + 1];

  dispatch({
    type: SET_SELECTED_GAME,
    target,
  });
};

export const handleBefore = () => (dispatch, getState) => {
  const { gamesOfToday, selectedGame } = getState().game;
  let currentIdx = gamesOfToday?.findIndex(
    (item) => item.key === selectedGame?.key,
  );
  let target = selectedGame;
  if (currentIdx <= 0) target = gamesOfToday[gamesOfToday.length - 1];
  else target = gamesOfToday[currentIdx - 1];

  dispatch({
    type: SET_SELECTED_GAME,
    target,
  });
};

export const setSelectedGame = (target) => (dispatch) => {
  dispatch({
    type: SET_SELECTED_GAME,
    target,
  });
};

export const setCompletedState = () => (dispatch, getState) => {
  const { selectedGame } = getState().game;
  dispatch({
    type: SET_COMPLETED_STATE,
    target: selectedGame,
  });
};

export const countryGameCompleted = () => (dispatch) => {
  dispatch({
    type: COUNTRY_GAME_COMPLETED,
  });
};

export const patchGameCountry = (payload) => (dispatch) => {
  dispatch({
    type: PATCH_GAME_COUNTRY,
    payload,
  });
};

export const neighboursGameCompleted = () => (dispatch) => {
  dispatch({
    type: NEIGHBOURS_GAME_COMPLETED,
  });
};

export const patchGameNeighbours = (payload) => (dispatch) => {
  dispatch({
    type: PATCH_GAME_NEIGHBOURS,
    payload,
  });
};

export const capitalGameCompleted = () => (dispatch) => {
  dispatch({
    type: CAPITAL_GAME_COMPLETED,
  });
};

export const patchGameCapital = (payload) => (dispatch) => {
  dispatch({
    type: PATCH_GAME_CAPITAL,
    payload,
  });
};

export const flagsGameCompleted = () => (dispatch) => {
  dispatch({
    type: FLAG_GAME_COMPLETED,
  });
};

export const patchGameFlags = (payload) => (dispatch) => {
  dispatch({
    type: PATCH_GAME_FLAG,
    payload,
  });
};

export const spokenLanguageGameCompleted = () => (dispatch) => {
  dispatch({
    type: SPOKEN_LANGUAGE_GAME_COMPLETED,
  });
};

export const patchGameSpokenLanguage = (payload) => (dispatch) => {
  dispatch({
    type: PATCH_GAME_SPOKEN_LANGUAGE,
    payload,
  });
};

export const populationGameCompleted = () => (dispatch) => {
  dispatch({
    type: POPULATION_GAME_COMPLETED,
  });
};

export const patchGamePopulation = (payload) => (dispatch) => {
  dispatch({
    type: PATCH_GAME_POPULATION,
    payload,
  });
};

export const currencyGameCompleted = () => (dispatch) => {
  dispatch({
    type: CURRENCY_GAME_COMPLETED,
  });
};

export const patchGameCurrency = (payload) => (dispatch) => {
  dispatch({
    type: PATCH_GAME_CURRENCY,
    payload,
  });
};

export const populousCitesGameCompleted = () => (dispatch) => {
  dispatch({
    type: POPULOUS_CITIES_GAME_COMPLETED,
  });
};

export const patchGamePopulousCites = (payload) => (dispatch) => {
  dispatch({
    type: PATCH_GAME_POPULOUS_CITIES,
    payload,
  });
};

export const areaGameCompleted = () => (dispatch) => {
  dispatch({
    type: AREA_GAME_COMPLETED,
  });
};

export const patchGameArea = (payload) => (dispatch) => {
  dispatch({
    type: PATCH_GAME_AREA,
    payload,
  });
};
